var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex bg header"},[(_vm.icon)?_c('md-icon',{attrs:{"name":"arrow-left","size":"lg"},on:{"click":_vm.goBack}}):_vm._e(),_c('div',{class:_vm.icon ? '' : 'flex-center'},[_vm._v(_vm._s(_vm.title))]),_c('div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }